
import Modal from "components/Models/index";
import useScreenMobile from "hooks/useScreen";
import React, { useState } from "react";
import "./editTeam.scss";
import Drawer from "components/Drawer/index";
import EditTeamRoles from "./EditTeamRoles/index";
import Button from "components/Button/index";
import { Team as izTeam } from "@induz/sdk";
import { useToast } from "components/Toaster/index";

const EditTeamContent = ({ onUpdateTeam, handleCancel, team }) => {
  const [roleData, setRoleData] = useState({
    operations: team?.operations || []
  });
  // Update selected operations
  const updateOperations = (operations) => {
    setRoleData((prev) => ({ ...prev, operations }));
  };
  const showToast = useToast();
  // Handle update button click
  const handleUpdate = async () => {
    try{
    const updatedTeam = {
      roles: team?.roles, // Preserve original role name
      operations: roleData.operations
    };
    // Comment: This calls onUpdateTeam, which will handle API update in ManageTeam
    await izTeam.updateTeam(updatedTeam.roles, updatedTeam.operations);
    showToast("Team updated successfully", "success");
    onUpdateTeam(updatedTeam);
    handleCancel(); // Close modal/drawer after submission
  } catch (error) {
    showToast("Failed to update team", "error");
    console.error("Error updating team:", error);
  }
  };

  return (
    <div className="EditTeam">
      <div className="EditTeamTop">
         <h1>
          Edit&nbsp;Team&nbsp;&ndash;&nbsp;
          <span style={{ fontWeight: 700,  
                  color: "#9B2FAB",        
                  fontSize: "30px",      
                  lineHeight: 1.2,   }}>{team?.roles ?? ""}
            </span>
        </h1>
        <p className="text">Can edit roles in team</p>
      </div>
      <div className="EditTeamWrapper">
        <div className="EditTeamWrapperContent">
          <EditTeamRoles
            team={team}
            updateOperations={updateOperations}
            handleCancel={handleCancel}
          />
        </div>
        <Button type="violet" title="Update" onClick={handleUpdate} />
      </div>
    </div>
  );
};

function EditTeam({ handleCancel, onUpdateTeam, team }) {
  const isMobile = useScreenMobile({ size: 992 });
  return (
    <>
      {isMobile ? (
        <Drawer showFooter={false} handleCancel={handleCancel} isVisible={true}>
          <EditTeamContent
            onUpdateTeam={onUpdateTeam}
            handleCancel={handleCancel}
            team={team}
          />
        </Drawer>
      ) : (
        <Modal
          title={"Edit Team"}
          showFooter={false}
          showCross={true}
          handleCancel={handleCancel}
          padding={"40px"}
        >
          <EditTeamContent
            onUpdateTeam={onUpdateTeam}
            handleCancel={handleCancel}
            team={team}
          />
        </Modal>
      )}
    </>
  );
}

export default EditTeam;